export default __webpack_public_path__ + "static/media/pokeball-cover.11812779.png";